import { render } from "./scoringDetailslist.vue?vue&type=template&id=29f89598&scoped=true"
import script from "./scoringDetailslist.vue?vue&type=script&lang=js"
export * from "./scoringDetailslist.vue?vue&type=script&lang=js"

import "./scoringDetailslist.vue?vue&type=style&index=0&id=29f89598&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f89598"]])

export default __exports__